import React from 'react';
import { motion } from 'framer-motion';
export function LeadershipReadiness() {
  return <section className="py-24 lg:py-32 px-4 sm:px-6 lg:px-8 bg-[#0F3050] text-white" data-id="element-1469" data-mp="3pyosclfzt8sl">
      <div className="max-w-4xl mx-auto text-center" data-id="element-1470" data-mp="3upx59rgj7cai">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1471" data-mp="3uqgjoy6z3ijs">
          <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-6 block" data-id="element-1472" data-mp="370m8sm67s426">
            Leadership Readiness
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold mb-8 leading-tight" data-id="element-1473" data-mp="3gz1rq1v3870l">
            Better leadership should be built, not assumed
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-surface-muted/80 leading-relaxed text-left md:text-center mb-12" data-id="element-1474" data-mp="w8aybae5tglf">
            <p data-id="element-1475" data-mp="1siwt2x70td0o">
              As responsibility increases, the framework becomes more rigorous.
              For civil servants and senior officials, the focus shifts toward
              integrity, systems thinking, judgment under pressure, and
              institutional responsibility.
            </p>
            <p data-id="element-1476" data-mp="1ehsr6gzpymrk">
              For ministers, governors, prime ministers, presidents, and
              executive leadership, it expands into crisis reasoning, escalation
              management, consequence modeling, misinformation handling, and
              governance stability.
            </p>
          </div>

          <div className="inline-block border-t border-white/20 pt-8" data-id="element-1477" data-mp="10s8v1u0n8nr8">
            <p className="text-xl md:text-2xl font-heading font-medium text-white" data-id="element-1478" data-mp="vsw5v2mav4lh">
              Leadership should be treated as a capability domain,{' '}
              <br className="hidden md:block" data-id="element-1479" data-mp="qvdu74gweb9s" />
              not merely a branding exercise.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}